import React from "react";
import { useState, useEffect, useContext } from "react";
import { Button } from "@material-ui/core";
import { UserContext } from "../../context/UserContext";
import LeftProfile from "./LeftProfile";
import RightProfile from "./RightProfile";
import "../../styles/profile.css";

export default function ProfileGrid({
  defaultUser,
  curUser,
  setCurUser,
  closeForm,
  setCloseForm,
}) {
  const { user } = useContext(UserContext);

  const handleCloseForm = (e) => {
    e.preventDefault();
    setCloseForm(!closeForm);
  };

  return (
    <>
      {/* <h1>Profile page</h1> */}

      {/* <Button
        className="update_btn"
        variant="contained"
        onClick={handleCloseForm}
        >
        OPEN
        </Button> */}

      <div className="profileGrid homeGrid">
        <LeftProfile
          curUser={curUser}
          setCurUser={setCurUser}
          setCloseForm={setCloseForm}
          closeForm={closeForm}
          defaultUser={defaultUser}
        />
        <RightProfile
          curUser={curUser}
          setCurUser={setCurUser}
          setCloseForm={setCloseForm}
          closeForm={closeForm}
        />
      </div>
    </>
  );
}
